// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { scrollSepolia as _scrollSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the scrollSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 534351
 * Chain Name: Scroll Sepolia
 * Default Block Explorer: https://sepolia.scrollscan.com
 * Default RPC URL: https://sepolia-rpc.scroll.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { scrollSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: scrollSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const scrollSepolia = createCommon({
	..._scrollSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
